module.exports = __webpack_public_path__ + "img/multimalla.106c1f2c.jpg";